import imgFairLogo from '@/assets/img/fair-logo.svg';

export default function Header({ feedbackButton = null }: { feedbackButton?: React.ReactNode }) {
  return (
    <div className="bg-primary-light pt-4 pb-0 w-full flex justify-center items-center">
      <div className="flex justify-between items-center w-full max-w-[800px] mx-auto px-[18px] lg:px-0">
        <div className="flex items-center gap-2.5">
          <img
            src={imgFairLogo}
            alt="logo"
            width={70}
            height={25}
            className="h-5 w-auto"
            style={{ aspectRatio: '70 / 25' }}
            fetchPriority="high"
          />
        </div>
        <div className="hidden">{feedbackButton}</div>
      </div>
    </div>
  );
}
